const cache = new Map();
const inflight = new Map();

const cacheFetcher = (key, fn) => async (...args) => {
  const lookupKey = args.length ? `${key}::${JSON.stringify(args)}` : key;

  if (cache.has(lookupKey)) {
    return cache.get(lookupKey);
  }
  if (inflight.has(lookupKey)) {
    return inflight.get(lookupKey);
  }

  const promise = Promise.resolve()
    .then(() => fn(...args))
    .then((result) => {
      cache.set(lookupKey, result);
      return result;
    })
    .finally(() => {
      inflight.delete(lookupKey);
    });

  inflight.set(lookupKey, promise);
  return promise;
};

const clearFetcherCache = (key) => {
  if (key === undefined) {
    cache.clear();
    inflight.clear();
    return;
  }
  for (const k of cache.keys()) {
    if (k === key || k.startsWith(`${key}::`)) {
      cache.delete(k);
    }
  }
  for (const k of inflight.keys()) {
    if (k === key || k.startsWith(`${key}::`)) {
      inflight.delete(k);
    }
  }
};

export { cacheFetcher, clearFetcherCache };
